import React from "react";
import PropTypes from "prop-types";
import VmoResponsiveLine from "../Nivo/VmoResponsiveLine";
import { getGridYValues, maxOfGraph } from "../../../helper";

const defaultAxisBottom = {
  tickRotation: 0,
  legend: "Time",
  legendOffset: 55,
};

const defaultAxisLeft = {
  tickRotation: 0,
  legend: "Reactions",
  legendOffset: -45,
};

const defaultLegends = {
  anchor: "top",
  direction: "row",
  translateX: 0,
  translateY: -40,
  itemsSpacing: 0,
  itemDirection: "left-to-right",
  itemWidth: 73,
  itemHeight: 23,
};

const VmoLine = ({
  data = [],
  margin = { top: 37, right: 27, bottom: 70, left: 60 },
  curve = "monotoneX",
  axisBottom: axisBottomObj = {},
  axisLeft: axisLeftObj = {},
  colors = { scheme: "nivo" },
  sliceTooltip,
  showLegends = true,
  legends: legendsObj = {},
}) => {
  const axisBottom = { ...defaultAxisBottom, ...axisBottomObj };
  const axisLeft = { ...defaultAxisLeft, ...axisLeftObj };
  const legends = { ...defaultLegends, ...legendsObj };

  return (
    <VmoResponsiveLine
      data={data}
      enableGridX={false}
      margin={margin}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: 0,
        max: maxOfGraph(data),
        stacked: false,
        reverse: false,
      }}
      curve={curve}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickSize: 5,
        tickPadding: 5,
        tickRotation: axisBottom.tickRotation,
        legend: axisBottom.legend,
        legendOffset: axisBottom.legendOffset,
        legendPosition: "middle",
      }}
      axisLeft={{
        format: axisLeft.format,
        tickValues: getGridYValues(data),
        orient: "left",
        tickSize: 5,
        tickPadding: 5,
        tickRotation: axisLeft.tickRotation,
        legend: axisLeft.legend,
        legendOffset: axisLeft.legendOffset,
        legendPosition: "middle",
      }}
      colors={colors}
      lineWidth={3}
      pointSize={5}
      gridYValues={getGridYValues(data)}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      enableSlices="x"
      useMesh
      sliceTooltip={sliceTooltip}
      legends={[
        ...(showLegends
          ? [
              {
                anchor: legends.anchor,
                direction: legends.direction,
                justify: false,
                translateX: legends.translateX,
                translateY: legends.translateY,
                itemsSpacing: legends.itemsSpacing,
                itemDirection: legends.itemDirection,
                itemWidth: legends.itemWidth,
                itemHeight: legends.itemHeight,
                itemOpacity: 0.75,
                symbolSize: 13,
                symbolShape: "circle",
                symbolBorderColor: "rgba(0, 0, 0, .5)",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemBackground: "rgba(0, 0, 0, .03)",
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]
          : []),
      ]}
    />
  );
};

export default VmoLine;

VmoLine.propTypes = {
  data: PropTypes.array,
  margin: PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
  }),
  curve: PropTypes.string,
  axisBottom: PropTypes.shape({
    tickRotation: PropTypes.number,
    legend: PropTypes.string,
    legendOffset: PropTypes.number,
  }),
  axisLeft: PropTypes.shape({
    format: PropTypes.func,
    tickRotation: PropTypes.number,
    legend: PropTypes.string,
    legendOffset: PropTypes.number,
  }),
  colors: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object,
  ]),
  sliceTooltip: PropTypes.func,
  showLegends: PropTypes.bool,
  legends: PropTypes.shape({
    anchor: PropTypes.string,
    direction: PropTypes.string,
    translateX: PropTypes.number,
    translateY: PropTypes.number,
    itemsSpacing: PropTypes.number,
    itemDirection: PropTypes.string,
    itemWidth: PropTypes.number,
    itemHeight: PropTypes.number,
  }),
};

VmoLine.defaultProps = {
  data: [],
  margin: {
    top: 37,
    right: 27,
    bottom: 70,
    left: 60,
  },
  curve: "monotoneX",
  axisBottom: {
    tickRotation: 0,
    legend: "Time",
    legendOffset: 55,
  },
  axisLeft: {
    tickRotation: 0,
    legend: "Reactions",
    legendOffset: -45,
  },
  colors: { scheme: "nivo" },
  legends: {
    anchor: "top",
    direction: "row",
    translateX: 0,
    translateY: -40,
    itemsSpacing: 0,
    itemDirection: "left-to-right",
    itemWidth: 73,
    itemHeight: 23,
  },
};
